<script setup lang="ts">
/**
 * Onboarding tour — step 1 body (M4C-14).
 *
 * Welcome / first fragments: a five-per-row grid of fragment glyphs beside a
 * large "+N" reward, then the congratulations message. The chrome (progress
 * header, footer nav, border, backdrop) is owned by the tour shell (M4C-13);
 * this component renders body content only.
 */
withDefaults(
  defineProps<{
    /** Number of star dust fragments awarded — drives the grid and the "+N". */
    count?: number;
  }>(),
  { count: 20 },
);

const { t } = useI18n();
</script>

<template>
  <div class="flex flex-col gap-16">
    <!-- Reward row: fragment grid + "+N" -->
    <div class="flex items-center gap-4">
      <div class="grid auto-rows-[28px] grid-cols-[repeat(5,28px)]">
        <GamiFragment v-for="n in count" :key="n" />
      </div>
      <p class="text-h1">+{{ count }}</p>
    </div>

    <!-- Message block -->
    <div class="flex flex-col gap-2">
      <p class="text-[1.5rem] font-bold leading-8">
        {{ t('onboarding.tour.step1.congratulations') }}
      </p>
      <p class="text-h1">
        {{ t('onboarding.tour.step1.message', { count }) }}
      </p>
    </div>
  </div>
</template>
